import React, { PureComponent } from 'react';

class GreyCircle extends PureComponent {
  render = (): React.ReactElement => {
    return (
      <svg
        width="15.5"
        height="15.5"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="7" cy="7" r="7" fill="#676767" />
      </svg>
    );
  };
}

export default GreyCircle;
